import { useApi } from './api';
import { URLS } from '../constants/urls';

export function useTurmaService() {
    const { authenticatedFetch } = useApi();

    const criarTurma = async (dados) => {
        const response = await authenticatedFetch(URLS.CREATE_TURMA, {
            method: 'POST',
            body: JSON.stringify(dados),
        });

        return response.json();
    };

    const atualizarTurma = async (dados) => {
        const response = await authenticatedFetch(URLS.UPDATE_TURMA, {
            method: 'POST',
            body: JSON.stringify(dados),
        });

        return response.json();
    };

    const deletarTurma = async (id) => {
        const response = await authenticatedFetch(URLS.DELETE_TURMA, {
            method: 'POST',
            body: JSON.stringify({ id }),
        });

        return response.json();
    };

    const listarTurmasPorEmpresa = async (idEmpresa) => {
        const response = await authenticatedFetch(URLS.READ_TURMA_BY_EMPRESA, {
            method: 'POST',
            body: JSON.stringify({ idEmpresa }),
        });

        return response.json();
    };

    const listarTurmas = async () => {
        const response = await authenticatedFetch(URLS.READ_ALL_TURMA);
        return response.json();
    };

    const obterTurmaPorId = async (id) => {
        const response = await authenticatedFetch(URLS.READ_TURMA, {
            method: 'POST',
            body: JSON.stringify({ id }),
        });

        return response.json();
    };

    const toggleStatusTurma = async (idTurma) => {
        const response = await authenticatedFetch(URLS.TOGGLE_STATUS_TURMA, {
            method: 'POST',
            body: JSON.stringify({ idTurma }),
        });

        return response.json();
    };

    const associarParticipanteATurma = async (idParticipante, idTurma) => {
        const response = await authenticatedFetch(URLS.CREATE_PARTICIPANTE_TURMA, {
            method: 'POST',
            body: JSON.stringify({ idParticipante, idTurma }),
        });

        return response.json();
    };

    /* ============================================================
     *          SERVIÇOS PARA TURMA LEMBRETE DATA
     * ============================================================ */

    const criarLembreteTurma = async (dados) => {
        const response = await authenticatedFetch(URLS.CREATE_LEMBRETE_TURMA, {
            method: 'POST',
            body: JSON.stringify(dados),
        });

        return response.json();
    };

    const atualizarLembreteTurma = async (dados) => {
        const response = await authenticatedFetch(URLS.UPDATE_LEMBRETE_TURMA, {
            method: 'POST',
            body: JSON.stringify(dados),
        });

        return response.json();
    };

    const deletarLembreteTurma = async (id) => {
        const response = await authenticatedFetch(URLS.DELETE_LEMBRETE_TURMA, {
            method: 'POST',
            body: JSON.stringify({ id }),
        });

        return response.json();
    };

    const deletarLembretesPorTurma = async (idTurma) => {
        const response = await authenticatedFetch(URLS.DELETE_BY_TURMA_LEMBRETE_TURMA, {
            method: 'POST',
            body: JSON.stringify({ idTurma }),
        });

        return response.json();
    };

    const listarTodosLembretesTurma = async () => {
        const response = await authenticatedFetch(URLS.READ_ALL_LEMBRETE_TURMA, {
            method: 'POST',
            body: JSON.stringify({}),
        });

        return response.json();
    };

    const obterLembreteTurmaPorId = async (id) => {
        const response = await authenticatedFetch(URLS.READ_BY_ID_LEMBRETE_TURMA, {
            method: 'POST',
            body: JSON.stringify({ id }),
        });

        return response.json();
    };

    const listarLembretesPorTurma = async (idTurma) => {
        const response = await authenticatedFetch(URLS.READ_BY_TURMA_LEMBRETE_TURMA, {
            method: 'POST',
            body: JSON.stringify({ idTurma }),
        });

        return response.json();
    };

    return {
        // Turmas
        criarTurma,
        atualizarTurma,
        deletarTurma,
        listarTurmas,
        listarTurmasPorEmpresa,
        obterTurmaPorId,
        toggleStatusTurma,
        associarParticipanteATurma,

        // Lembretes de turma
        criarLembreteTurma,
        atualizarLembreteTurma,
        deletarLembreteTurma,
        deletarLembretesPorTurma,
        listarTodosLembretesTurma,
        obterLembreteTurmaPorId,
        listarLembretesPorTurma,
    };
}
